<template>
  <div class="navbar-content">
    <div class="d-flex justify-end align-center" style="width: 100%; height:62px;">
      <div class="profile-wrapper">
        <div class="profile">
          <v-icon
            @click="toggleProfileWrapper(false)"
            v-click-outside="toggleProfileWrapper"
          >
            mdi-account-circle-outline
          </v-icon>
          <div class="profile-list" :hidden="profileWrapper">
            <div class="profile-item" style="display: flex">
              <div class="photo">
                <v-icon large> mdi-account-circle-outline </v-icon>
              </div>
              <div class="profile-detail">
                <h5>{{$store.state.name}}</h5>
                <p>{{$store.state.role}}</p>
              </div>
            </div>
            <hr class="divider mb-1" />
            <div class="profile-item">
              <router-link to="/profile" class="profile-link">
                <span class="profile-item-overlay"></span>
                <v-icon right> mdi-account </v-icon>
                <span class="ml-2">Profile</span>
              </router-link>
            </div>
            <div class="profile-item">
              <a href="/" @click="logout" class="profile-link">
                <span class="profile-item-overlay"></span>
                <v-icon right> mdi-logout </v-icon>
                <span class="ml-2">Logout</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toggleProfileWrapper(isDirective = true) {
      if (isDirective !== false) {
        if (!this.profileWrapper) this.profileWrapper = true;
      } else this.profileWrapper = !this.profileWrapper;
    },
    logout(event){
      event.preventDefault();
      this.$cookies.remove("token")
      this.$router.push("/")
    }
  },
  data() {
    return {
      profileWrapper: true,
      focused: true,
      searchValue: ""
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/components/styles/variable';

.search-border{
    border-bottom: 1px solid rgba(var(--v-theme-primary), var(--v-high-emphasis-opacity))
}
.search-wrapper {
  padding: 12px 0;
}
.navbar-content {
  margin-block-start: 0.75rem;
  padding-inline: 1.5rem;
  background-color: #fff;
  border-radius: 0.3rem;
  margin-bottom: 12px;
}

.div-desinty {
  margin-right: 5px;
  display: inline;
  width: calc(var(--v-btn-height) + 10px);
  height: calc(var(--v-btn-height) + 10px) !important;
  padding: 0 !important;
  background-color: #fff !important;
  box-shadow: none;
}
.profile {
  cursor: pointer;
  position: relative;

  .profile-list {
    --pading-profile: 10px 10px;
    position: absolute;
    z-index: 50;
    cursor: default;
    right: 0;
    top: 40px;
    min-width: 200px;
    background: #fff;
    box-shadow: 0 5px 5px -3px var(--v-shadow-key-umbra-opacity),
      0 8px 10px 1px var(--v-shadow-key-penumbra-opacity),
      0 3px 14px 2px var(--v-shadow-key-ambient-opacity);
    .profile-item {
      padding: var(--pading-profile);
      position: relative;
      .photo {
        margin-right: 8px;
      }
      .profile-item-overlay{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: $color-primary;
        opacity: $opacity-low;
        display: none;
      }
      .profile-detail {
        h5 {
          font-size: 1rem;
          font-weight: 500;
          color: rgba(#000, var(--v-medium-emphasis-opacity));
        }
        p {
          font-size: 0.8rem;
          margin: 0;
          text-transform: lowercase;
          color: rgba(#000, var(--v-medium-emphasis-opacity));
        }
      }
      .profile-link {
        font-size: 1rem;
        display: inline-block;
        width: 100%;
        color: rgba(#000, var(--v-medium-emphasis-opacity));

        & + .profile-link{
          margin-top: 10px;
        }

        &:hover .profile-item-overlay{
          display: block;
        }
      }
    }
  }
}
</style>
